import unionBy from 'lodash/unionBy';
import { MarketPage } from '@/interface/enum';
import { EnumEventDateFilterType, EnumPresetFilterType } from '@/types';

export function getFilter(marketPage: MarketPage) {
    const mapping: Record<MarketPage, { presetFilter: EnumPresetFilterType, date: EnumEventDateFilterType }> = {
        [MarketPage.Live]: { presetFilter: EnumPresetFilterType.Live, date: EnumEventDateFilterType.All },
        [MarketPage.Today]: { presetFilter: EnumPresetFilterType.NonLive, date: EnumEventDateFilterType.TodayExpanded },
        [MarketPage.EarlyMarket]: { presetFilter: EnumPresetFilterType.NonLive, date: EnumEventDateFilterType.EarlyMarket },
        [MarketPage.All]: { presetFilter: EnumPresetFilterType.All, date: EnumEventDateFilterType.All },
        [MarketPage.EarlyMarketPlus1]: { presetFilter: EnumPresetFilterType.NonLive, date: EnumEventDateFilterType.Plus1 },
        [MarketPage.EarlyMarketPlus2]: { presetFilter: EnumPresetFilterType.NonLive, date: EnumEventDateFilterType.Plus2 },
        [MarketPage.EarlyMarketPlus3]: { presetFilter: EnumPresetFilterType.NonLive, date: EnumEventDateFilterType.Plus3 },
        [MarketPage.EarlyMarketPlus4Over]: { presetFilter: EnumPresetFilterType.NonLive, date: EnumEventDateFilterType.Plus4Over },
        [MarketPage.Outright]: { presetFilter: EnumPresetFilterType.Outright, date: EnumEventDateFilterType.All },
        [MarketPage.MixParlay]: { presetFilter: EnumPresetFilterType.MixParlay, date: EnumEventDateFilterType.All },
        [MarketPage.Unknown]: { presetFilter: EnumPresetFilterType.All, date: EnumEventDateFilterType.All },
    };
    return mapping[marketPage];
}

export function getPresetFilter(marketPage: MarketPage) {
    const mapping: Partial<Record<MarketPage, EnumPresetFilterType>> = {
        [MarketPage.Live]: EnumPresetFilterType.Live,
        [MarketPage.Today]: EnumPresetFilterType.NonLive,
        [MarketPage.EarlyMarket]: EnumPresetFilterType.NonLive,
    };
    return mapping[marketPage];
}

export function mergeSubscriptionResult<T extends { id: string | number }>(
    oldList: T[],
    { updated = [], deleted = [] } = {},
    keySelector = (x: T) => x.id,
) {
    if (!oldList) return null;

    return unionBy(updated, oldList, keySelector)
        .filter(o => !deleted.find(d => keySelector(o) === (keySelector(d) ?? d)));
}
